// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, consistent-return, new-cap, babel/new-cap */
import { OrderedMap } from "immutable"
import PendingRequest from "@kiwicom/frontend-common/records/PendingRequest"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"

import { STATUS } from "../../../components/BookingPendingRequests/consts/pendingRequestConsts"

export default function (requests = []) {
  try {
    return requests
      .filter((request) => request.status === STATUS.PENDING)
      .reduce((acc, x) => acc.set(x.id, new PendingRequest(x)), OrderedMap())
  } catch (err) {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_PENDING_REQUESTS_UNSUPPORTED_FORMAT, {
      requests,
      err,
    })
  }
}
